import { useEffect, useState } from "react";
import api from "@/lib/api";
import { Quote, Star } from "lucide-react";

const ROLE_LABEL = {
  farmer: "Hobby Farmer",
  driver: "Driver",
  client: "Client",
  wholesale: "Wholesale Buyer",
  admin: "Team",
};

export default function Testimonials({ farmerId = null, limit = 6, className = "" }) {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const params = { limit };
    if (farmerId) params.farmer_id = farmerId;
    api.get("/testimonials", { params })
      .then((r) => setItems(r.data))
      .finally(() => setLoading(false));
  }, [farmerId, limit]);

  if (loading) return null;
  if (items.length === 0) return null;

  return (
    <section className={`max-w-7xl mx-auto px-6 sm:px-12 ${className}`} data-testid="testimonials-section">
      <div className="text-[11px] uppercase tracking-[0.3em] text-emerald-800 font-semibold">From the community</div>
      <h2 className="mt-3 font-serif text-4xl sm:text-5xl text-stone-900 max-w-3xl">
        What our network says.
      </h2>

      <div className="mt-10 grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
        {items.map((t) => (
          <div
            key={t.id}
            data-testid={`testimonial-${t.id}`}
            className="bg-white border border-stone-200 rounded-md p-7 flex flex-col"
          >
            <Quote className="text-emerald-800/20" size={32} strokeWidth={1.5} />
            <p className="mt-4 font-serif text-lg text-stone-800 leading-relaxed flex-1">"{t.quote}"</p>
            {t.rating && (
              <div className="mt-4 flex gap-0.5 text-amber-600">
                {Array.from({ length: 5 }).map((_, i) => (
                  <Star key={i} size={14} fill={i < t.rating ? "currentColor" : "none"} />
                ))}
              </div>
            )}
            <div className="mt-4 pt-4 border-t border-stone-100">
              <div className="font-sans text-sm text-stone-900 font-semibold">{t.name}</div>
              <div className="text-xs text-stone-500 mt-0.5 font-sans">
                {ROLE_LABEL[t.role] || t.role}{t.state ? ` · ${t.state}` : ""}
              </div>
              {t.farmer_name && (
                <div className="text-xs text-emerald-800 mt-1 font-sans">about {t.farmer_name}</div>
              )}
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}
